import { render, staticRenderFns } from "./TaskScreen.vue?vue&type=template&id=ccd1c2a2&scoped=true"
import script from "./TaskScreen.vue?vue&type=script&lang=js"
export * from "./TaskScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd1c2a2",
  null
  
)

export default component.exports